module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"lt":{"meta":{"title":{"complement":"Nogrid","inner":"APVA parama saulės elektrinėms","separator":"-"}}},"pl":{}}')
  delete Component.options._Ctor
}
